// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CustomerServiceTwoToneSvg from "@fishx/icons-svg/es/asn/CustomerServiceTwoTone";
import FishxIcon from '../components/FishxIcon';

var CustomerServiceTwoTone = function CustomerServiceTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CustomerServiceTwoToneSvg
  }));
};

CustomerServiceTwoTone.displayName = 'CustomerServiceTwoTone';
export default React.forwardRef(CustomerServiceTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CustomerServiceTwoTone.js
// module id = 2359
// module chunks = 0